export default __webpack_public_path__ + "static/media/68.34b56236.jpeg";